import { Link, useNavigate } from "react-router-dom";
import Logo from "../image/Logo text.png";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../utils/firebase";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addUser, removeUser } from "../store/userSlice";
import { toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { clearFollow } from "../store/followSlice";
import { MULTI_LANG } from "../utils/constants";
import { addBot, addForm, addLang, removeForm } from "../store/configAppSlice";
import lang from "../utils/langConstants";
import Cookies from "js-cookie";
import { handleLogOut } from "../Service/LogourService";

const Header = () => {
  const user = useSelector((store) => store.user);
  const Langkey = useSelector((store) => store.configApp.lang);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const userLogin = Cookies.get("user");
  const signup_profile = Cookies.get("signup_profile");

  const navigate = useNavigate();
  const liCSS =
    "pt-1 font-semibold p-0 focus:text-purple-300  hover:text-purple-300 uppercase tracking-wide text-sm 2xl:text-lg lg:text-sm cursor-pointer focus:border-purple-400 hover:border-purple-400 border-b-2 border-transparent lii pb-1";
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid, displayName, email } = user;
        dispatch(addUser({ uid, displayName, email }));
        dispatch(removeForm());
      } else {
        dispatch(removeUser());
      }
    });

    return () => unsubscribe();
  }, []);

  // Close dropdown when userLogin state changes (prevents it from staying open after login)
  useEffect(() => {
    setDropdownOpen(false);
  }, [userLogin]);

  return (
    <>
      <div className="z-50 fixed w-full mb-20 bg-gradient-to-b from-black bg-opacity-100 py-1 flex-row flex items-center justify-between px-3 2xl:px-10 lg:px-6 md:px-10">
        <div>
          <Link to={"/"}>
            <img
              className="w-32 lg:py-3 py-3 2xl:py-7 2xl:w-72 md:w-44 lg:w-48"
              src={Logo}
              alt="Logo"
            />
          </Link>
        </div>

        <div className="text-white lg:gap-5 gap-5 2xl:gap-8 justify-center items-center hidden lg:flex">
          <Link to={"/about"} className={liCSS}>
            <span>{lang[Langkey].ABOUT}</span>
          </Link>
          <Link to={"/zodiacSign"} className={liCSS}>
            <span>{lang[Langkey].ZodiacSign}</span>
          </Link>

          {!signup_profile &&
            (userLogin ? (
              <div
                className="relative"
                onMouseEnter={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
              >
                <span className="pt-1 font-semibold p-0 focus:text-purple-300 hover:text-purple-300 uppercase tracking-wide text-sm 2xl:text-lg lg:text-sm cursor-pointer pb-1">
                  Profile
                </span>
                {dropdownOpen && (
                  <div className="absolute right-0 w-48 bg-[#020416] text-white rounded-lg shadow-lg py-2">
                    <Link
                      to="/buy-coin"
                      className="block px-4 py-2 hover:bg-purple-800 hover:text-purple-300 rounded-md transition"
                    >
                      Buy Coin
                    </Link>
                    <Link
                      to="/"
                      className="block px-4 py-2 hover:bg-purple-800 hover:text-purple-300 rounded-md transition"
                    >
                      Home
                    </Link>
                    <Link
                      to="/edit_profile"
                      className="block px-4 py-2 hover:bg-purple-800 hover:text-purple-300 rounded-md transition"
                    >
                      Edit Profile
                    </Link>
                    <Link
                      to="/feedback"
                      className="block px-4 py-2 hover:bg-purple-800 hover:text-purple-300 rounded-md transition"
                    >
                      Feedback
                    </Link>
                    <span
                      onClick={() => handleLogOut(navigate)}
                      className="block px-4 py-2 hover:bg-red-600 hover:text-white rounded-md cursor-pointer transition"
                    >
                      Logout
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className={liCSS}>
                Login
              </Link>
            ))}
        </div>
      </div>
    </>
  );
};

export default Header;
